<template>
  <div>
    <search-base-esim-product @submit="submitSearch" />

    <div class="simiot-table-operation-buttons">
      <a-space>
        <a-button
          type="primary"
          @click="showNewModal"
          v-if="isShowMenu('base_esim_products/new')"
        >新增</a-button>

        <update-base-esim-product-effective
          v-if="isShowMenu('base_esim_products/effective')"
          :selected-row-keys="selectedRowKeys"
          @completed="fetchData"
        />
      </a-space>
    </div>

    <a-table
      size="middle"
      :scroll="{ x: 'max-content' }"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      row-key="id"
    >
      <span slot="actions" slot-scope="text, record">
        <a-dropdown>
          <a class="ant-dropdown-link" @click="e => e.preventDefault()">
            操作 <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item v-if="isHasEditPermission">
              <a @click="showEditModal(record.id)">编辑</a>
            </a-menu-item>
            <a-menu-item>
              <a @click="showOperationHistoryModal(record.id)">操作历史</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

    <new-base-esim-product
      v-if="isShowNewModal"
      :visible.sync="isShowNewModal"
      @completed="fetchData"
    />

    <edit-base-esim-product
      v-if="isShowEditModal"
      :visible.sync="isShowEditModal"
      :id="editingId"
      @completed="fetchData"
    />

    <operation-history-list-modal
      v-if="isShowOperationHistoryModal"
      :reference-id="showingOperationHistoryId"
      reference-type="BaseEsimProduct"
      :visible.sync="isShowOperationHistoryModal"
    />
  </div>
</template>

<script>
import { hasPermission } from '@/utils/permission'
import { findBaseEsimProducts } from '@/api/base_esim_product'
import Pagination from '@/components/Pagination'
import SearchBaseEsimProduct from '@/views/base_esim_products/Search'

export default {
  name: 'BaseEsimProductList',
  components: {
    Pagination,
    SearchBaseEsimProduct,
    NewBaseEsimProduct: () => import('@/views/base_esim_products/New'),
    EditBaseEsimProduct: () => import('@/views/base_esim_products/Edit'),
    UpdateBaseEsimProductEffective: () => import('@/views/base_esim_products/UpdateEffective'),
    OperationHistoryListModal: () => import('@/views/operation_histories/Modal')
  },
  data() {
    return {
      data: [],
      columns: [
        { title: '产品名称', dataIndex: 'name', width: 180 },
        { title: 'SGP规范', dataIndex: 'sgp_spec_names', width: 180 },
        { title: '有效性', dataIndex: 'effective', width: 100 },
        { title: '创建时间', dataIndex: 'created_at', width: 170 },
        { title: '操作', key: 'actions', scopedSlots: { customRender: 'actions' }, fixed: 'right', width: 100 }
      ],
      loading: true,
      selectedRowKeys: [],
      pagination: { total_count: 0 },
      query: { per_page: 10 },
      isShowNewModal: false,
      isShowEditModal: false,
      editingId: 0,
      isShowOperationHistoryModal: false,
      showingOperationHistoryId: 0
    }
  },
  computed: {
    isHasEditPermission() {
      return hasPermission('base_esim_products/edit')
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    isShowMenu(permission) {
      return hasPermission(permission)
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    submitSearch(search) {
      this.query = Object.assign({}, this.$options.data().query, { per_page: this.query.per_page }, search)
      this.fetchData()
    },
    showNewModal() {
      this.isShowNewModal = true
    },
    showEditModal(id) {
      this.editingId = id
      this.isShowEditModal = true
    },
    showOperationHistoryModal(id) {
      this.showingOperationHistoryId = id
      this.isShowOperationHistoryModal = true
    },
    fetchData() {
      this.loading = true
      this.selectedRowKeys = []
      findBaseEsimProducts(this.query).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      })
    }
  }
}
</script>
